import { Card, CardContent } from "@/components/ui/card";
import { AlertCircleIcon, CheckCircle2Icon, ClockIcon } from "lucide-react";

type LotsSummaryCardsProps = {
  expiredCount: number;
  nearExpiryCount: number;
  healthyCount: number;
  isLoading?: boolean;
};

export function LotsSummaryCards({
  expiredCount,
  nearExpiryCount,
  healthyCount,
  isLoading,
}: LotsSummaryCardsProps) {
  if (isLoading) {
    return (
      <div className="grid gap-4 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="rounded-xl border bg-card">
            <CardContent>
              <div className="h-10 animate-pulse rounded bg-muted" />
              <div className="mt-2 h-6 w-16 animate-pulse rounded bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-3">
      <Card className="rounded-xl border border-destructive/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-destructive/10">
            <AlertCircleIcon className="size-5 text-destructive" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">Lot ຫມົດອາຍຸ</p>
            <p className="font-semibold text-2xl tabular-nums">
              {expiredCount.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-amber-500/10">
            <ClockIcon className="size-5 text-amber-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ໃກ້ຫມົດອາຍຸ (30 ວັນ)</p>
            <p className="font-semibold text-2xl tabular-nums">
              {nearExpiryCount.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-emerald-500/20 bg-card">
        <CardContent className="flex items-center gap-4">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-emerald-500/10">
            <CheckCircle2Icon className="size-5 text-emerald-600" />
          </div>
          <div>
            <p className="text-muted-foreground text-sm">ສະຕ໋ອກປອດໄພ</p>
            <p className="font-semibold text-2xl tabular-nums">
              {healthyCount.toLocaleString("lo-LA")}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
